import * as ACTION_TYPES from './types';

const initialState = {
  isSidebarCollapsed: false,
  visibleWidget: '',
  available: false,
  openPool: false,
  offline: false,
  toastPosition: 'bottom-left',
  toast: null,
  aiNotes: false,
  isShowAiCheckerTooltip: false,
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ACTION_TYPES.UI_TOGGLE_SIDEBAR:
      return {
        ...state,
        isSidebarCollapsed: !state.isSidebarCollapsed,
      };
    case ACTION_TYPES.UI_TOGGLE_SETTINGS:
      return {
        ...state,
        available: payload.available,
      };
    case ACTION_TYPES.UI_SET_OPEN_POOL:
      return {
        ...state,
        openPool: payload.status,
      };
    case ACTION_TYPES.UI_SET_OFFLINE:
      return {
        ...state,
        offline: payload.offline,
      };
    case ACTION_TYPES.UI_SET_TOAST_POSITION:
      return {
        ...state,
        toastPosition: payload.toastPosition,
      };

    case ACTION_TYPES.UI_SHOW_TOAST:
      return {
        ...state,
        toast: payload,
      };
    case ACTION_TYPES.UI_CLEAR_TOAST:
      return {
        ...state,
        toast: null,
      };
    case ACTION_TYPES.UI_TOGGLE_AI_NOTE_MODAL:
      return {
        ...state,
        aiNotes: payload,
      };
    case ACTION_TYPES.UI_SHOW_AI_CHECKER_TOOLTIP:
      return {
        ...state,
        isShowAiCheckerTooltip: payload,
      };

    default:
      return state;
  }
}
